module.exports = __webpack_public_path__ + "media/src/images/logo-iversity-e7bef76db335bdba5e566979ccc16a68.png";